document.addEventListener("DOMContentLoaded", function() {
    const ulElement = document.querySelector(".book-wrapper__buy-section ul");
    if (ulElement) {
      const liElements = ulElement.querySelectorAll("li");
      if (liElements.length > 0) {
        for (let i = 0; i < liElements.length; i++) {
          if (liElements[i].textContent.startsWith("First Issue:")) {
            const textAfterFirstIssue = liElements[i].textContent.split(":")[1];
            liElements[i].textContent = "Current Issue:" + textAfterFirstIssue;
            break;
          }
        }
      }
    } 
  });